// Test IDs for preview components

export const PREVIEW_TEST_IDS = {
  LAYERS_PREVIEW: 'layers-preview',
  MODEL_PREVIEW: 'model-preview',
  INFO_ICON_CONTAINER: 'model-preview-info-icon-container',
} as const;

export const PREVIEW_HEADER_TEST_IDS = {
  ADD_ADDITIONAL_PRODUCT_BTN: 'add-additional-product-preview-btn',
  PRICE: 'price',
  DELIVERY: 'delivery',
  SAVE_BTN: 'save-btn',
  SIDE_PANEL_SAVE_BTN: 'side-panel-save-btn',
} as const;

export const PREVIEW_TOGGLE_TEST_IDS = {
  MODEL_VIEW_TOGGLE: 'model-view-toggle',
  LAYERS_VIEW_TOGGLE: 'layers-view-toggle',
} as const;

export const PREVIEW_SLIDER_TEST_IDS = {
  PREVIEW_SLIDER_CONTAINER: 'preview-slider-container',
  PREVIOUS_ARROW: 'preview-previous-arrow',
  NEXT_ARROW: 'preview-next-arrow',
} as const;
